// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"281":"03e954fa","774":"40ffd40c"}[chunkId] + ".js";
};